import React from 'react';
import { ArrowUpRightIcon } from 'lucide-react';
import { HeroBackgroundVideo } from './HeroBackgroundVideo';
import { principles } from '../data/site';
export function Hero() {
  return <section id="top" className="bg-ink" data-id="element-45" data-mp="9kjvgl9o4y23">
      <div className="relative min-h-[780px] overflow-hidden md:min-h-[640px] lg:min-h-[700px]" data-id="element-46" data-mp="9lbhb4dgrhf6">
        <HeroBackgroundVideo data-id="element-47" data-mp="4n9zemrrxo5a" />

        <div className="relative z-10 mx-auto flex min-h-[780px] max-w-content flex-col justify-start px-5 pb-24 pt-10 sm:px-6 md:min-h-[640px] md:px-8 md:pt-20 lg:min-h-[700px] lg:px-10" data-id="element-48" data-mp="4jvup7vn12uo">
          <div className="max-w-[650px]" data-id="element-49" data-mp="x8b7dnrar92u">
            <h1 className="font-display text-[40px] font-semibold leading-[1.04] tracking-[-0.025em] text-cream sm:text-[56px] lg:text-[66px]" data-id="element-50" data-mp="sarsqmqosuad">
              Small studio.
              <br data-id="element-51" data-mp="3d1ikl9ryvcnf" />
              <span className="text-violet" data-id="element-52" data-mp="3d21sdxnwkknq">
                Big apps
                <span className="text-gold" data-id="element-53" data-mp="3cz5vmcnsk20v">.</span>
              </span>
            </h1>

            <p className="mt-7 max-w-lg text-[17px] leading-relaxed text-cream/80" data-id="element-54" data-mp="384jur3fc5rv1">
              Black Comet Labs builds original apps for learning, life and play. A focused
              portfolio. High standards. Plenty of personality.
            </p>

            <div className="mt-10 flex flex-wrap items-center gap-6" data-id="element-55" data-mp="399ba3kjqp7ue">
              <a href="#lab" className="inline-flex min-h-[52px] items-center gap-2 rounded-[2px] bg-violet px-7 text-[15px] font-medium text-ink transition-colors duration-150 ease-out hover:bg-violet/85" data-id="element-56" data-mp="3e961rqbca1gi">
                Explore the lab
                <ArrowUpRightIcon className="h-4 w-4" aria-hidden="true" data-id="element-57" data-mp="2qjv8etwbj9ce" />
              </a>
              <a href="#story" className="inline-flex min-h-[44px] items-center border-b border-cream/40 text-[15px] font-medium text-cream/90 transition-colors duration-150 ease-out hover:border-cream hover:text-cream" data-id="element-58" data-mp="2qi0mbc9b9b6q">
                The studio
              </a>
            </div>
          </div>
        </div>
      </div>

      <div className="border-t border-cream/15" data-id="element-59" data-mp="s3mbny4btqw9">
        <dl className="mx-auto grid max-w-content grid-cols-1 gap-px bg-cream/15 sm:grid-cols-2 lg:grid-cols-4" data-id="element-60" data-mp="nbl3anaa4kbi">
          {principles.map(principle => <div key={principle.title} className="bg-ink px-5 py-9 md:px-8 lg:px-10" data-id="element-61" data-mp="ichxh0mh6a2h">
              <dt className="font-display text-[26px] font-medium leading-none text-cream md:text-[28px]" data-id="element-62" data-mp="deq92gl1h631">
                {principle.title}
              </dt>
              <dd className="mt-3 text-[14px] leading-relaxed text-cream/60" data-id="element-63" data-mp="161b01fxlrg62">{principle.caption}</dd>
            </div>)}
        </dl>
      </div>
    </section>;
}